'use client';

import { Avatar } from '@mui/material';
import clsx from 'clsx';
import { Author } from './types';

function Authors({
    authors,
    locale,
    avatarClassName = '',
}: Readonly<{
    authors?: Author[];
    locale?: string;
    avatarClassName?: string;
}>) {
    if (!authors || authors.length === 0) {
        return null;
    }

    return (
        <div className="flex items-center overflow-hidden">
            {/* 头像部分 - 始终显示所有头像 */}
            <div className="flex flex-none">
                {authors.map((author: Author, index: number) => (
                    <div
                        key={`avatar-${author.name}-${index}`}
                        className={clsx(
                            'tablet:h-[24px] tablet:w-[24px] h-[21px] w-[21px]',
                            {
                                'ml-[-4px]': index > 0, // 重叠显示头像
                            },
                            avatarClassName,
                        )}
                        style={{ zIndex: authors.length - index }} // 确保正确的层级
                    >
                        <Avatar
                            sx={{
                                width: '100%',
                                height: '100%',
                                border: '1px solid white', // 添加白色边框区分重叠的头像
                            }}
                            src={author.avatar}
                            alt={author.name}
                        />
                    </div>
                ))}
            </div>

            {/* 名字部分 - 可能被截断 */}
            <div className="tablet:ml-[6px] j-t2 ml-[4px] min-w-0 truncate">
                {authors.map((author: Author, index: number) => (
                    <span key={`name-${author.name}-${index}`}>
                        {author.name}
                        {index === authors.length - 1 ? '' : ', '}
                    </span>
                ))}
            </div>
        </div>
    );
}

export default Authors;
